module.exports = __webpack_public_path__ + "img/select1.50e8e0e5.png";